import LandingLayout from '@/components/landing/home/LandingLayout';
import PartnerSignupComponent from '@/components/landing/home/PartnerSignup';
import React from 'react';

const PartnerSignup = () => {
  return (
    <LandingLayout>
      <div className="">
        <PartnerSignupComponent />
      </div>
    </LandingLayout>
  );
};

export default PartnerSignup;
